import apiCore from '../../utils/api-core';

export function getBotsModules(botId) {
	return apiCore.get(`/api/v1/bots/${botId}/modules`);
}

export function createModule(body) {
	return apiCore.post( '/api/v1/modules', body);
}

export function updateModule(id,body) {
	return apiCore.put( `/api/v1/modules/${id}`, body);
}

export function deleteModule(id) {
	return apiCore.delete( `/api/v1/modules/${id}` );
}

export function getModuleGroups() {
	return apiCore.get('/api/v1/module-group');
}

export function getUserModuleGroups() {
	return apiCore.get('/api/v3/module-group/user');
}

export function getDefaultCalendarModuleGroups(){
	return apiCore.get('/api/v1/module-group/calendar-defaults');
}

export function getUserCalendarTimeSlots(fromDate, availabilitySettings = null, timezone = null){
	const parts = [];
	if (availabilitySettings) parts.push(`availability_settings=${encodeURIComponent(JSON.stringify(availabilitySettings))}`);
	if (timezone) parts.push(`timezone=${encodeURIComponent(timezone)}`);
	const params = parts.length ? `?${parts.join('&')}` : '';
	return apiCore.get(`/api/v1/integrations/calendar-preview/${fromDate}${params}`);
}

export function getCalendarPreviewTimeSlotsByUser(userId,fromDate){
	return apiCore.get(`/api/v1/integrations/calendar-preview/${userId}/${fromDate}`);
}

export function getModuleGroup(modulegroupId) {
	return apiCore.get(`/api/v1/module-group/${modulegroupId}/modules`);
}

export function updateModuleGroup(modulegroupId, data) {
	return apiCore.put(`/api/v1/module-group/${modulegroupId}`, data);
}

export function createModuleGroup(data) {
	return apiCore.post('/api/v1/module-group', data);
}

export function deleteModuleGroup(modulegroupId) {
	return apiCore.delete(`/api/v1/module-group/${modulegroupId}`);
}

export function updateModuleFollowups(id,body) {
	return apiCore.put( `/api/v1/modules/followups/${id}`, body);
}

export function updateModuleBotRedirects(id,body) {
	return apiCore.put( `/api/v1/modules/botredirect/${id}`, body);
}

export function createModuleTag(data) {
	return apiCore.post('/api/v1/module/tag', data);
}

export function updateModuleTag(data) {
	return apiCore.put('/api/v1/module/tag', data);
}

export function deleteModuleTag(id){
	return apiCore.delete(`/api/v1/module/tag/${id}`);
}

export function getModuleGroupsByCompany(company_id) {
	return apiCore.get(`/api/v1/module-group/${company_id}`);
}